export default __webpack_public_path__ + "static/media/nangan3.24287eec.jpg";